import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("slideShowImage4", component(opts));
  editor.BlockManager.add("slideShowImage4", block(opts));
};